// extracted by mini-css-extract-plugin
export var leftAlign = "_1g-2";
export var popper = "_1g-0";
export var subtitle = "_1g-1";